import Index from '../../pages/servitor/nmrj/index';
import Help from '../../pages/servitor/nmrj/help';

const base = 'nmrj';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/servitor/nmrj.js